export const SIGN_UP_STEP = 'SIGN_UP_STEP'
export const PAYMENT_CONFIRMATION_STEP = 'PAYMENT_CONFIRMATION_STEP'
export const SIGN_UP_REQUEST_EMAIL_STEP = 'SIGN_UP_REQUEST_EMAIL_STEP'
export const SIGN_UP_STEP_PLAN = 'SIGN_UP_STEP_PLAN'
export const CHECK_YOUR_EMAIL_STORAGE = 'CHECK_YOUR_EMAIL_STORAGE'
